import { MindboxOperation } from '~/enums/mindbox-operation'
import helpers from '~/helpers'
import type { OperationData, ProductListItem, SetSearchData, ViewCategoryData, ViewProductData } from '~/types/mindbox'
import type { ProductData } from '~/types/products'

declare global {
  // noinspection JSUnusedGlobalSymbols
  interface Window {
    mindbox: (
      type: string,
      payload: {
        data: OperationData
        onError: (e: object) => void
        onSuccess: () => void
        operation: MindboxOperation
      }
    ) => void
  }
}

function execute (mindboxOperation: MindboxOperation, data: OperationData = {} as Record<string, never>): void {
  if (!Object.hasOwn(window, 'mindbox')) {
    return
  }

  try {
    // noinspection JSUnusedGlobalSymbols
    window.mindbox('async', {
      data,
      onError: function (e: object): void {
        console.error(e)
      },
      onSuccess: function (): void {},
      operation: mindboxOperation
    })
  } catch (e) {
    console.error(e)
  }
}

export function setSearch (productsData: ProductData[]): void {
  const data: SetSearchData = {
    productList: productsData.map(
      (x: ProductData): ProductListItem => ({
        count: 1,
        pricePerItem: helpers.getProductPrice(x)!,
        product: {
          ids: {
            itab: x.id
          }
        }
      })
    )
  }

  execute(MindboxOperation.WebsiteSetSearch, data)
}

export function viewCategory (categoryId: string): void {
  const data: ViewCategoryData = {
    viewProductCategory: {
      productCategory: {
        ids: {
          itab: categoryId
        }
      }
    }
  }

  execute(MindboxOperation.WebsiteViewCategory, data)
}

export function viewProduct (productId: string): void {
  const data: ViewProductData = {
    viewProduct: {
      product: {
        ids: {
          itab: productId
        }
      }
    }
  }

  execute(MindboxOperation.WebsiteViewProduct, data)
}
